import { combineReducers } from "@reduxjs/toolkit";
import { SET_CITIES, SET_COUNTRIES, SET_SECTIONS } from "./actions/reducers";

const countriesReducer = (state: string[] = [], action: any) => {
	switch (action.type) {
		case SET_COUNTRIES:
			return action.payload;
		default:
			return state;
	}
};

const citiesReducer = (state: string[] = [], action: any) => {
	switch (action.type) {
		case SET_CITIES:
			return action.payload;
		default:
			return state;
	}
};

const sectionsReducer = (state: string[] = [], action: any) => {
	switch (action.type) {
		case SET_SECTIONS:
			return action.payload;
		default:
			return state;
	}
};

const zoneReducer = combineReducers({
	countries: countriesReducer,
	cities: citiesReducer,
	sections: sectionsReducer,
});

export type ZoneState = ReturnType<typeof zoneReducer>;
export default zoneReducer;
